import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';

/**
 * Ensures httpOnly cookies are sent with requests.
 * assets/i18n URLs stay without credentials, matching the previous class interceptor.
 */
export function credentialsInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (request.url.indexOf('assets/i18n') >= 0) {
    return next(request);
  }

  return next(request.clone({ withCredentials: true }));
}
